import { faPen, faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import MultiSelectDropdown from '../../components/dropdown/MultiSelectDropdown.js';
import ValidationText from '../../utils/validation/ValidationText.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';

class JVEntry extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices()
        this.SwalServices = new SwalServices()
        this.accountServices = new AccountServices()
        this.state = {
            isGridView: true,
            isEditing: false,
            index: null,
            jvEntryList: [],
            isLoading: false,
            tableStatus: "",
            filterDetails: {
                partyName: "",
                arrangedBy: "Select",
            },
            jvDetails: {
                jvEntryId: "",
                srNo: "",
                date: "",
                totalDebitAmount: 0,
                totalCreditAmount: 0
            },
            jvItemDetails: {
                drcrDropDown: "Dr",
                partyId: "",
                partyName: "",
                runningBalance: "",
                creditAmount: "",
                debitAmount: "",
                narration1: "",
                narration2: "",
                voucherNo: "",
                date: "",
                entryType: "JVEntry",
                from: "JVEntryDebit",
            },
            partyDropdownList: [],
            jvEntryItemList: [],
            drcrDropDownList: [
                { drcrDropDown: "Dr", value: "dr" },
                { drcrDropDown: "Cr", value: "cr" },
            ],
            arrangedByList: [
                { arrangedBy: "SR No.", value: "srNo" },
                { arrangedBy: "Date", value: "date" },
                { arrangedBy: "Credit Amount", value: "creditAmount" },
                { arrangedBy: "Debit Amount", value: "debitAmount" },
            ],
            validationRules: {
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "account name"
                        ),
                    },
                ],
            },
            creditAmountValidation: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace(
                        "{0}",
                        "credit amount"
                    ),
                },
            ],
            debitAmountValidation: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace(
                        "{0}",
                        "debit amount"
                    ),
                },
            ],
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getAllJVEntry()
    }

    getAllJVEntry = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.accountServices.getAllJVEntry(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState({ jvEntryList: response.responseData }, () => {
                    this.getAllPartyDropdown()
                })
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown();
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                }));
                this.setState({ partyDropdownList: dropdownItems });
            } else {

                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    isValidAllFields = () => {
        let validationRules = { ...this.state.validationRules }
        if (this.state.jvItemDetails.drcrDropDown === 'Dr') {
            validationRules.debitAmount = this.state.debitAmountValidation
        } else if (this.state.jvItemDetails.drcrDropDown === 'Cr') {
            validationRules.creditAmount = this.state.creditAmountValidation
        }
        const newValidState = isValidForm(
            this.state.jvItemDetails,
            validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.resetItemDetailsForm()
        this.setState({ isGridView: true });
    };

    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}

        let filterDetails = this.state.filterDetails
        // filterDetails.partyName = ""
        // filterDetails.arrangedBy = "srNo"

        let jvDetails = this.state.jvDetails
        jvDetails.srNo = ""
        jvDetails.date = ""
        jvDetails.jvEntryId = ""
        jvDetails.totalDebitAmount = 0
        jvDetails.totalCreditAmount = 0

        this.setState({ filterDetails: filterDetails, jvDetails: jvDetails, validState: validState, jvEntryItemList: [] },
            () => {
                this.getAllJVEntry()
            }
        );
    }

    resetItemDetailsForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let jvItemDetails = this.state.jvItemDetails
        jvItemDetails.drcrDropDown = "Dr"
        jvItemDetails.partyId = ""
        jvItemDetails.partyName = ""
        jvItemDetails.runningBalance = ""
        jvItemDetails.creditAmount = ""
        jvItemDetails.debitAmount = ""
        jvItemDetails.narration1 = ""
        jvItemDetails.narration2 = ""
        jvItemDetails.voucherNo = ""
        jvItemDetails.date = ""
        jvItemDetails.from = "JVEntryDebit"
        this.setState({ jvItemDetails: jvItemDetails, index: null, isEditing: false, validState: validState })
    }

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details });
        } else if (section === "jvDetails") {
            let details = this.state.jvDetails;
            details[name] = value.toUpperCase();
            this.setState({ jvDetails: details });
        } else if (section === 'jvItemDetails') {
            let details = this.state.jvItemDetails;
            details[name] = value.toUpperCase();
            this.setState({ jvItemDetails: details });
        }
    };

    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = select;
            this.setState({ filterDetails: details }, () => {
                this.getAllJVEntry()
            });
        } else if (section === "jvDetails") {
            let details = this.state.jvDetails;
            details[name] = select;
            this.setState({ jvDetails: details });
        } else if (section === 'jvItemDetails') {
            let details = this.state.jvItemDetails;
            if (name === "drcrDropDown") {
                if (select === "Dr") {
                    details.creditAmount = "";
                } else if (select === "Cr") {
                    details.debitAmount = "";
                }
                details[name] = select;
            }
            details[name] = select;
            this.setState({ jvItemDetails: details });
        }
    };

    setFilterParameters = (selected, drpIdentity) => {
        let details = this.state.jvItemDetails;
        details[drpIdentity] = selected.value;
        if (drpIdentity === 'partyId') {
            details.partyName = selected.label
            this.getRunningBalanceByPartyId(selected.value)
        }
        this.setState({ jvItemDetails: details });
    };

    getRunningBalanceByPartyId = (id) => {
        this.accountServices.getRunningBalanceByPartyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let closingBalance = JSON.stringify(response.responseData.closingBalance)
                let closingBalanceDRCR = response.responseData.closingBalanceDRCR
                let details = this.state.jvItemDetails
                details.runningBalance = closingBalance + ' ' + closingBalanceDRCR
                this.setState({ jvItemDetails: details })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getJVEntryVoucherNo = () => {
        this.accountServices.getJVEntryVoucherNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.jvDetails
                details.srNo = response.responseData.srNo
                details.date = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ jvDetails: details }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    addItemsInArray = () => {
        let list = [...this.state.jvEntryItemList];
        let details = { ...this.state.jvItemDetails };
        details.voucherNo = this.state.jvDetails.srNo
        details.date = this.state.jvDetails.date
        if (details.drcrDropDown === 'Cr') {
            details.from = "JVEntryCredit"
        } else if (details.drcrDropDown === 'Dr') {
            details.from = "JVEntryDebit"
        }

        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            if (this.state.index >= 0 && this.state.index !== null && this.state.index !== undefined) {
                list[this.state.index] = details
            } else {
                list.push(details);
            }
            this.setState({ jvEntryItemList: list, index: null }, () => {
                let totalDebitAmount = this.state.jvEntryItemList.reduce((sum, item) => sum + Number(item.debitAmount), 0);
                let totalCreditAmount = this.state.jvEntryItemList.reduce((sum, item) => sum + Number(item.creditAmount), 0);
                let details = this.state.jvDetails
                details.totalDebitAmount = totalDebitAmount
                details.totalCreditAmount = totalCreditAmount
                this.setState({ jvDetails: details })
                this.resetItemDetailsForm()
            })
        }
    }

    editDetailsFromJVEntryItemList = (item, index) => {
        let details = this.state.jvItemDetails
        details.drcrDropDown = item.drcrDropDown
        details.partyId = item.partyId._id
        details.debitAmount = item.debitAmount ? item.debitAmount : ""
        details.creditAmount = item.creditAmount ? item.creditAmount : ""
        details.narration1 = item.narration1
        details.narration2 = item.narration2
        this.setState({ jvItemDetails: details, index: index, isEditing: true }, () => {
            this.getRunningBalanceByPartyId(this.state.jvItemDetails.partyId)
        })
    }

    deleteDetailsFromJVEntryItemList = (index) => {
        let list = [...this.state.jvEntryItemList];
        list.splice(index, 1);
        this.setState({ jvEntryItemList: list });
    }

    addEditJVEntry = () => {
        if (this.state.jvEntryItemList.length > 1) {
            this.setState({ isLoading: true }, () => {
                let request = {
                    jvDetails: this.state.jvDetails,
                    jvEntryItemList: this.state.jvEntryItemList
                }
                this.accountServices.addEditJVEntry(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.SwalServices.Success(response.Message);
                        this.setState({ isGridView: true, isLoading: false }, () => {
                            this.openGridView()
                        })
                    } else {
                        this.openGridView()
                        this.setState({ isLoading: false })
                        this.SwalServices.Error(response.Message);
                    }
                });
            })
        } else {
            this.setState({ isLoading: false })
            this.SwalServices.Alert('At least two entries are required')
        }
    }

    getJVEntryById = (id) => {
        this.accountServices.getJVEntryById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                // let jvDetails = response.responseData.jvDetails
                // jvDetails.date = moment(jvDetails.date).format('yyyy-MM-DD')
                // jvDetails.jvEntryId = jvDetails._id

                let jvDetails = this.state.jvDetails
                jvDetails.date = moment(response.responseData.jvDetails.date).format('yyyy-MM-DD')
                jvDetails.jvEntryId = response.responseData.jvDetails._id
                jvDetails.srNo = response.responseData.jvDetails.srNo
                jvDetails.totalDebitAmount = response.responseData.jvDetails.totalDebitAmount
                jvDetails.totalCreditAmount = response.responseData.jvDetails.totalCreditAmount

                let jvEntryItemList = response.responseData.jvEntryItemList
                this.setState({ jvDetails: jvDetails, jvEntryItemList: jvEntryItemList }, () => {
                    this.setState({ isGridView: false })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteJVEntryById = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this JV Entry ?`
        ).then((response) => {
            if (response === true) {
                this.accountServices.deleteJVEntryById(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.SwalServices.Success(response.Message);
                        this.getAllJVEntry()
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }

    render() {
        return (
            <div className='JVEntry-page'>
                {this.state.isGridView === true ? (
                    <>
                        {/* 1. Item Search  */}
                        <div className="item-search">
                            <div className="item-grp flex gap-2.5 mb-2.5 w-[60%]">
                                <div className="search-grp w-[40%]">
                                    <label>Arranged By</label>
                                    <select
                                        name="arrangedBy"
                                        className="w-full"
                                        value={this.state.filterDetails.arrangedBy
                                            && this.state.filterDetails.arrangedBy !== 'Select'
                                            && this.state.arrangedByList.find((party) => party.value === this.state.filterDetails.arrangedBy).value}
                                        onChange={(event) =>
                                            this.handleDropDownChange(
                                                event,
                                                "arrangedBy",
                                                "filterDetails"
                                            )
                                        }
                                    >
                                        <option value="Select">Select</option>
                                        {this.state.arrangedByList.map((x, key) => (
                                            <option key={key} value={x.value}>
                                                {x.arrangedBy}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                            </div>
                            <button className="add-btn "
                                onClick={() => this.getJVEntryVoucherNo()}>
                                Add New
                            </button>
                        </div>

                        {/* 2. Item tabel  */}
                        <div className="itemList-table">
                            <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                                <table className="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[15%]'>SR No.</td>
                                            <td className='w-[15%]'>Date</td>
                                            <td className='w-[30%]'>Credit Amount</td>
                                            <td className='w-[25%]'>Debit Amount</td>
                                            <td className="w-[15%]" style={{ textAlign: "center" }}>Action</td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.jvEntryList && this.state.jvEntryList.length > 0 ? (
                                            this.state.jvEntryList.map((item, key) => (
                                                <tr key={key}>
                                                    <td>{item.srNo}</td>
                                                    <td>{moment(item.date).format('DD MMM yyyy')}</td>
                                                    <td>{Number(item.totalCreditAmount).toFixed(2)}</td>
                                                    <td>{Number(item.totalDebitAmount).toFixed(2)}</td>
                                                    <td className='!text-center'>
                                                        <button
                                                            className="search-btn"
                                                            onClick={() => this.getJVEntryById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        <button
                                                            className="cancel-btn"
                                                            onClick={() => this.deleteJVEntryById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : this.state.jvEntryList &&
                                            this.state.jvEntryList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.jvEntryList &&
                                            this.state.jvEntryList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                ) : null}



                {this.state.isGridView === false ? (
                    <>
                        <div className="item-form ">
                            <div className="item-grp flex gap-2.5 mb-3 w-[50%]">
                                <div className="input-grp w-full">
                                    <label>Voucher No</label>
                                    <input
                                        type="text"
                                        id="srNo"
                                        name="srNo"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.jvDetails.srNo}
                                        onChange={(event) =>
                                            this.handleChange(event, "srNo", "jvDetails")
                                        }
                                    />
                                </div>

                                <div className="input-grp w-full">
                                    <label>Date</label>
                                    <input
                                        type="date"
                                        id="date"
                                        name="date"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.jvDetails.date}
                                        onChange={(event) =>
                                            this.handleChange(event, "date", "jvDetails")
                                        }
                                    />
                                </div>
                            </div>
                            <hr />
                            <div className="item-grp flex gap-2.5 mb-3 mt-2.5">
                                <div className="search-grp min-w-[6%]">
                                    <label>Dr/Cr</label>
                                    <select
                                        name="drcrDropDown"
                                        className="w-full"
                                        value={this.state.jvItemDetails.drcrDropDown
                                            && this.state.jvItemDetails.drcrDropDown !== 'Select'
                                            && this.state.drcrDropDownList.find((party) => party.drcrDropDown === this.state.jvItemDetails.drcrDropDown).drcrDropDown}
                                        onChange={(event) =>
                                            this.handleDropDownChange(
                                                event,
                                                "drcrDropDown",
                                                'jvItemDetails'
                                            )
                                        }
                                    >
                                        {this.state.drcrDropDownList.map((x, key) => (
                                            <option key={key} value={x.drcrDropDown}>
                                                {x.drcrDropDown}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="input-grp min-w-[30%]">
                                    <label>Account Name</label>
                                    <MultiSelectDropdown
                                        drpIdentity="partyId"
                                        options={this.state.partyDropdownList}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        className={` ${this.state.validState?.error?.partyId ? "errorInput" : ""}`}
                                        onChange={(selected) =>
                                            this.setFilterParameters(selected, "partyId")
                                        }
                                        allowSelectAll={false}
                                        value={this.state.partyDropdownList.filter(
                                            (party) =>
                                                party.value === this.state.jvItemDetails.partyId
                                        )}
                                    />
                                    {/* <ValidationText error={this.state.validState.error.partyId} /> */}
                                </div>
                                <div className="input-grp w-full">
                                    <label>Running Balance</label>
                                    <input
                                        type="text"
                                        id="runningBalance"
                                        name="runningBalance"
                                        className="inputFocus"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.jvItemDetails.runningBalance}
                                        onChange={(event) =>
                                            this.handleChange(event, "runningBalance", 'jvItemDetails')
                                        }
                                    />
                                </div>
                                <div className="input-grp w-full">
                                    <label>Debit Amount</label>
                                    <input
                                        type="number"
                                        id="debitAmount"
                                        name="debitAmount"
                                        className={`inputFocus ${this.state.validState?.error?.debitAmount ? "errorInput" : ""}`}
                                        autocomplete="off"
                                        disabled={this.state.jvItemDetails.drcrDropDown === "Cr"}
                                        value={this.state.jvItemDetails.debitAmount}
                                        onChange={(event) =>
                                            this.handleChange(event, "debitAmount", 'jvItemDetails')
                                        }
                                    />
                                    {/* <ValidationText error={this.state.validState.error.debitAmount} /> */}
                                </div>
                                <div className="input-grp w-full">
                                    <label>Credit Amount</label>
                                    <input
                                        type="number"
                                        id="creditAmount"
                                        name="creditAmount"
                                        className={`inputFocus ${this.state.validState?.error?.creditAmount ? "errorInput" : ""}`}
                                        autocomplete="off"
                                        disabled={this.state.jvItemDetails.drcrDropDown === "Dr"}
                                        value={this.state.jvItemDetails.creditAmount}
                                        onChange={(event) =>
                                            this.handleChange(event, "creditAmount", 'jvItemDetails')
                                        }
                                    />
                                    {/* <ValidationText error={this.state.validState.error.creditAmount} /> */}
                                </div>
                            </div>
                            <div className="item-grp flex gap-2.5 mb-3">
                                <div className="input-grp w-full">
                                    <label>Narration</label>
                                    <input
                                        type="text"
                                        id="narration1"
                                        name="narration1"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.jvItemDetails.narration1}
                                        onChange={(event) =>
                                            this.handleChange(event, "narration1", 'jvItemDetails')
                                        }
                                    />
                                </div>
                                <div className="input-grp w-full">
                                    <label>Narration</label>
                                    <input
                                        type="text"
                                        id="narration2"
                                        name="narration2"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.jvItemDetails.narration2}
                                        onChange={(event) =>
                                            this.handleChange(event, "narration2", 'jvItemDetails')
                                        }
                                    />
                                </div>
                            </div>
                            <div className="btn-grp mb-4">
                                <button className="add-btn" onClick={() => this.addItemsInArray()}>{this.state.isEditing ? 'Save' : 'Add'}</button>
                                <button className="cancel-btn" onClick={() => this.resetItemDetailsForm()}>Cancel</button>
                            </div>

                            <div className="itemList-table">
                                <div className="table-container" style={{ height: "calc(100vh - 520px)" }}>
                                    <table className="itemList">
                                        <thead>
                                            <tr>
                                                <td className='w-[15%]'>SR No.</td>
                                                <td className='w-[15%]'>Dr/Cr</td>
                                                <td className='w-[30%]'>Account Name</td>
                                                <td className='w-[15%]'>Debit Amount</td>
                                                <td className='w-[15%]'>Credit Amount</td>
                                                <td className="w-[25%]" style={{ textAlign: "center" }}>Action</td>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.state.jvEntryItemList && this.state.jvEntryItemList.length > 0 ? (
                                                this.state.jvEntryItemList.map((item, key) => (
                                                    <tr key={key}>
                                                        <td>{key + 1}</td>
                                                        <td>{item.drcrDropDown}</td>
                                                        <td>{item.partyName ? item.partyName : item.partyId.partyName}</td>
                                                        <td>{item.debitAmount}</td>
                                                        <td>{item.creditAmount}</td>
                                                        <td className='!text-center'>
                                                            <button
                                                                className="search-btn"
                                                                onClick={() => this.editDetailsFromJVEntryItemList(item, key)}
                                                            >
                                                                <FontAwesomeIcon icon={faPen} />
                                                            </button>
                                                            <button
                                                                className="cancel-btn"
                                                                onClick={() => this.deleteDetailsFromJVEntryItemList(item._id)}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : this.state.jvEntryList && this.state.jvEntryList.length === 0 && this.state.noItemFound !== "" ? (
                                                <tr>
                                                    <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                        {this.state.noItemFound}
                                                    </td>
                                                </tr>
                                            ) : this.state.jvEntryList && this.state.jvEntryList.length === 0 && this.state.noItemFound === "" ? null : ""}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* <div>
                                <p>Total Credit Amount :- {this.state.jvDetails.totalCreditAmount}</p>
                                <p>Total Debit Amount :- {this.state.jvDetails.totalDebitAmount}</p>
                            </div> */}
                            <div className='flex justify-between mt-3 mb-3'>

                                <div className="item-sections w-[30%]  ml-auto !p-3  !bg-white rounded-[10px]" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px ', backgroundColor: "#f5f5f5" }}>
                                    <div className='flex gap-2.5 '>
                                        <div className="w-full">
                                            <label>Total Debit Amount</label>
                                            <input
                                                className='h-[36px]'
                                                type="number"
                                                id="totalDebitAmount"
                                                name="totalDebitAmount"
                                                autocomplete="off"
                                                disabled
                                                value={this.state.jvDetails.totalDebitAmount}
                                            />
                                        </div>
                                        <div className="w-full">
                                            <label>Total Credit Amount</label>
                                            <input
                                                className='h-[36px]'
                                                type="number"
                                                id="totalCreditAmount"
                                                name="totalCreditAmount"
                                                autocomplete="off"
                                                disabled
                                                value={this.state.jvDetails.totalCreditAmount}
                                            />
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <hr />
                            <div className="btn-grp mt-3">
                                <button className="add-btn " onClick={() => this.addEditJVEntry()} disabled={this.state.isLoading}>{this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}</button>
                                <button className="cancel-btn " onClick={() => this.openGridView()} disabled={this.state.isLoading}>Cancel</button>

                            </div>

                        </div>
                    </>
                ) : null}

            </div>
        );
    }
}

export default JVEntry;